import { Button, Group, Stack, Text } from '@cowbell/ui/core';
import { Modal } from '../../../components/modals/v2/helpers/v2.modal.helpers';

const MODAL_TEXT =
  'The ISO 22301 Alignment Assessment evaluates the tabletop exercise delivered in a Self Service plan, so the two are purchased together. This account doesn’t have a Self Service plan yet — we’ll add it to your request so you’re all set.';

interface AddSelfServiceModalProps {
  readonly data: {
    readonly onConfirm: () => void;
    readonly onCancel: () => void;
  };
  readonly close: () => void;
}

export const AddSelfServiceModal = ({
  data,
  close,
}: AddSelfServiceModalProps) => {
  const respond = (callback: () => void) => () => {
    close();
    callback();
  };

  return (
    <Stack p="md" gap="lg">
      <Text size="lg">{MODAL_TEXT}</Text>
      <Group justify="flex-end">
        <Button variant="default" size="lg" onClick={respond(data.onCancel)}>
          Not now
        </Button>
        <Button size="lg" onClick={respond(data.onConfirm)}>
          Add both &amp; continue
        </Button>
      </Group>
    </Stack>
  );
};

export const AddSelfServiceModalConfig = {
  AddSelfServiceModal: {
    component: AddSelfServiceModal,
    config: {
      fullWidth: true,
      title: 'Add Self Service too?',
      maxWidth: 'sm',
    },
  },
};

// Resolves true when the user adds both plans. Closing the modal any way counts as declining.
export const confirmAddSelfService = () =>
  new Promise<boolean>((resolve) => {
    Modal.show(AddSelfServiceModalConfig, {
      data: { onConfirm: () => resolve(true), onCancel: () => resolve(false) },
      config: {
        onClose: () => {
          Modal.hide();
          resolve(false);
        },
      },
    });
  });
